import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-basic-layout',
    templateUrl: './basic-layout.component.html',
    styleUrls: ['./basic-layout.component.scss'],
    standalone: false
})
export class BasicLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
